import { configCatProvider } from 'data/react-query/queries/useFeatureFlag';
import { logUncaught } from 'utils/log';
import { getUser } from 'utils/user';

import { PROBLEM_SESSION_RESCHEDULE_USER_IDS_FEATURE_FLAG } from './constants';

// ConfigCat text setting holding a JSON array of photographer user ids, e.g. "[4608823]".
export const isProblemSessionRescheduleEnabled = async () => {
  const { user_id: userId } = getUser();
  if (!userId) {
    return false;
  }

  try {
    const userIds = JSON.parse(
      await configCatProvider.getFeatureText(PROBLEM_SESSION_RESCHEDULE_USER_IDS_FEATURE_FLAG, '[]'),
    );
    return Array.isArray(userIds) && userIds.map(String).includes(String(userId));
  } catch (error) {
    logUncaught(error, { context: 'isProblemSessionRescheduleEnabled' });
    return false;
  }
};
